import { style } from "@vanilla-extract/css";
import { vars } from "../../styles/theme.css";

const captainIconBase = style({
  width: "100%",
  height: "100%",
});

export const captainStyles = style([
  captainIconBase,
  {
    color: vars.colors.white,
    fill: vars.colors.primaryFixed,
  },
]);

export const tripleCaptainStyles = style([
  captainIconBase,
  {
    color: vars.colors.primaryFixed,
    fill: vars.colors.white,
  },
]);
